<!-- メールテンプレートマスタ　新規登録画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wmail">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>メールテンプレートマスタ<span>新規</span></h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>
			<!-- ▽  -->
			<section class="inputArea">
				<div class="btnLst">
					<button class="confBtn" v-on:click="onConfirmRegisterModalOpen">登録</button>
					<!-- ↑ contntMenu「戻る」に変更 <button class="cancelBtn" v-on:click="onCancel">キャンセル</button>　-->
				</div>
				<table class="mailTemplate inputTbl">
					<thead>
						<tr>
							<th>項目名称</th>
							<td>登録内容</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th>分類</th>
							<td>
								<select v-model="mlbr">
									<option value="">選択してください</option>
									<option value="01">パスワードのお知らせ</option>
									<option value="02">予約申込時メール（受診者）</option>
									<option value="03">予約確定時メール（管理者）</option>
									<option value="04">予約変更時メール（受診者）</option>
									<option value="05">予約変更時メール（管理者）</option>
									<option value="06">予約キャンセル時メール（受診者）</option>
									<option value="07">予約キャンセル確定時メール（管理者）</option>
									<option value="08">受診前確認メール</option>
									<option value="09">受診勧奨メール</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>クライアント</th>
							<td>
								<select v-model="jgcd">
									<option value="">選択してください</option>
									<option v-for="list in listsJGYO" v-bind:value="list.JGCD">
										{{list.JGNM}}
									</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>コース</th>
							<td>
								<select v-model="kscd">
									<option value="">先にクライアントを選択してください</option>
									<option v-for="list in filterListsIRKS" v-bind:value="list.KSCD">
										{{list.KSNM}}
									</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>メールアドレス</th>
							<td>
								<ul class="eMail">
									<!--送信元-->
									<li><input type="text" v-model="otad" maxlength="60" placeholder="送信元"></li>
									<!--返信先-->
									<li><input type="text" v-model="repy" maxlength="60" placeholder="返信先"></li>
									<!--BCC-->
									<li><input type="text" v-model="bcc" maxlength="60" placeholder="BCC"></li>
								</ul>
							</td>
						</tr>
						<tr>
						<tr>
							<th>メールタイトル</th>
							<td><input type="text" v-model="titl" placeholder="メールタイトル"></td>
						</tr>
						<tr>
							<th>メール文章</th>
							<td><textarea v-model="naiy" placeholder="メール文章"></textarea></td>
						</tr>
					</tbody>
				</table>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<modalWindow v-show="modal.confirmRegister.isShow" v-on:close="onConfirmRegisterModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmRegister.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onRegister">OK</button></li>
					<li><button v-on:click="onConfirmRegisterCancel">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WMAILRegisterApi } from '@/api'
	import { WMAILRegisterFirstDisplayApi } from '@/api'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWMAILRegister',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
		computed: {
			filterListsIRKS: function () {

				var tempListIRKS = this.listsIRKS.filter(list => {
					return list.JGCD == this.jgcd
				})
				return tempListIRKS
			}
		},
		data() {
			return {
				jgcd: '',
				kscd: '',
				mlbr: '',
				titl: '',
				naiy: '',
				otad: '',
				repy: '',
				bcc: '',
				// クライアントプルダウン
				listsJGYO: [],
				// コースプルダウン（フィルタ前）
				listsIRKS: [],
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmRegister: {
						messages: [
							'登録しますか？'
						],
						isShow: false
					},
				}
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWMAILRegister::created Start')

			var tempircd = this.$store.state.auth.ircd

			// 非同期通信(クライアント)
			WMAILRegisterFirstDisplayApi.RegisterFirstDisplay({
				token: this.$store.state.auth.token,
				ircd: tempircd
			}).then(({ responce }) => {

				this.listsJGYO = responce.data.listJGYO
				this.listsIRKS = responce.data.listIRKS
			}).catch(() => {
				// システムエラー時
				this.onSystemErrorModalOpen()
			}).finally(() => {
				UtilityConsoleLog.consoleLog('MasterWMAILRegister::created End')
			})
		},
		watch: {
			// クライアントコードが変わるとコースコードが初期値に戻る
			jgcd: function (jgcd) {
				this.kscd = ''
			}
		},
		methods: {
			//登録用
			onRegister: function () {
				UtilityConsoleLog.consoleLog("MasterWMAILRegister::onRegister Start")

				var tempircd = this.$store.state.auth.ircd
				var tempjgcd = this.jgcd
				var tempkscd = this.kscd
				var tempmlbr = this.mlbr
				var temptitl = this.titl
				var tempnaiy = this.naiy
				var tempotad = this.otad
				var temprepy = this.repy
				var tempbcc = this.bcc

				WMAILRegisterApi.Register({
					token: this.$store.state.auth.token,
					ircd: tempircd,
					jgcd: tempjgcd,
					kscd: tempkscd,
					mlbr: tempmlbr,
					titl: temptitl,
					naiy: tempnaiy,
					otad: tempotad,
					repy: temprepy,
					bcc: tempbcc
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						//登録確認モーダルを閉じる
						this.onConfirmRegisterModalClose()

						//登録完了モーダルを開く
						this.$router.push("/MasterWMAILRegisterDone")

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()							
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION) {
						//入力項目でのエラー
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					}

				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWMAILRegister::onRegister End')
				})
			},
			//一覧表示画面に戻る
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWMAILRegister::onCancel Start")

				this.$router.push("/MasterWMAILList")

				UtilityConsoleLog.consoleLog("MasterWMAILRegister::onCancel End")
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				cUtilityConsoleLog.consoleLog('MasterWMAILRegister::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onSystemErrorModalClose End')
			},
			// 登録確認モーダルを開く
			onConfirmRegisterModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onConfirmRegisterModalOpen Start')

				this.modalOpen('confirmRegister')

				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onConfirmRegisterModalOpen End')
			},
			// 登録確認モーダルを閉じる
			onConfirmRegisterModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onConfirmRegisterModalClose Start')

				this.modalClose('confirmRegister')

				UtilityConsoleLog.consoleLog('MasterWMAILRegister::onConfirmRegisterModalClose End')
			},
			////登録確認モーダルで表示画面に戻る
			onConfirmRegisterCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWMAILRegister::onConfirmRegisterCancel Start")

				this.modalClose('confirmRegister')

				UtilityConsoleLog.consoleLog("MasterWMAILRegister::onConfirmRegisterCancel End")
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWMAILRegister::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWMAILRegister::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWMAILRegister::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWMAILRegister::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WMAIL/MasterWMAILRegister.vue